import { FormDialog } from 'components/dialog/form'
import { useSearchForm, SearchForm } from '../form/searchForm'

import { SearchResult, useEditSearch } from 'interface/search'

type EditSearchDialogProps = {
  data: SearchResult
  onSubmit: (result: SearchResult) => void
  onClose: () => void
}
export const EditSearchDialog = ({
  data,
  onSubmit,
  onClose
}: EditSearchDialogProps) => {
  const form = useSearchForm(data)
  const {
    form: {
      formState: { isValid },
      handleSubmit
    }
  } = form

  const [postState, editSearch] = useEditSearch(data.searchId, { onEditted: onSubmit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="sm"
      title="分析依頼を編集"
      encType="multipart/form-data"
      isLoading={postState.posting || form.isLoading}
      error={postState.error}
      body={<SearchForm {...form}/>}
      submitLabel="保存"
      isValid={isValid}
      onSubmit={handleSubmit(form => editSearch(form))}
      onClose={onClose}
    />
  )
}
